// src/mocks/data/runningAccount.demo.js
// Fictitious client names — values match production snapshot (Apr 2026)

export const accountList = [];

export const accountDetail = {};

export const accountMovements = [];

export const accountSummaryCustomers = [];

// Aggregate stats for the overview tiles + Top 5 table
// Shape consumed by fetchAggregateStatistics → response.data → aggregateStats
export const aggregateStats = {
    success: true,
    data: {
        clients: { active: 8 },
        balance: {
            total:        493531,
            updatedTotal: 497521,   // shown as "Precios actuales: $497,521 (+0.8%)"
        },
        invoicing: { pendingItems: 349 },
        movements: { today: 2 },
        topClients: [
            { clientId: 101, businessName: 'BEATRIZ ALEJANDRA VELASQUEZ', currentBalance: 298096.47, lastMovement: '2026-04-18' },
            { clientId: 102, businessName: 'GASTON MANUEL PEREYRA',       currentBalance:  75948.37, lastMovement: '2026-04-19' },
            { clientId: 103, businessName: 'NAHUEL EZEQUIEL GUZMAN',      currentBalance:  70282.72, lastMovement: '2026-04-09' },
            { clientId: 104, businessName: 'LUCAS ROBERTO DELGADO',       currentBalance:  54116.05, lastMovement: '2026-04-20' },
        ],
    },
};
